import React from 'react';

import './contact-form.scss';
import cs from "classnames";
import ContactFormInput from '../../contact-form-input/contact-form-input';



const ContactFormEn = ({ formId, title }) => {
  const [ success, setSuccess ] = React.useState(false);
  const [ error, setError ] = React.useState(false);
  const [ company, setCompany ] = React.useState();
  const [ project, setProject ] = React.useState();
  const [ email, setEmail ] = React.useState();
  const [ phone, setPhone ] = React.useState();
  const [ name, setName ] = React.useState();
  const [ country, setCountry ] = React.useState();
  const width = window.innerWidth;



  const onSubmit = event => {
    event.preventDefault();

    const url = '/svalka/api/expressform/';
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ company, project, email, phone, name })
    };

    fetch(url, requestOptions)
        .then((response => response.json()))
        .then((json) => {
          const { ok, text } = json;
          if (ok) {
            setSuccess(true);
            setError(false);
            if (window.ym) {
              window.ym(5320750,'reachGoal','com_order_sent');
            }
            return;
          }

          if (text) {
            window.alert(text);
            return;
          }

          setError(true);
          setSuccess(false);
        })
        .catch(() => {
          setError(true);
          setSuccess(false);
        })
  }

  return (
      <React.Fragment>
        <section className="contactus" id="contact">
          <div
              id="l-express-form-container"
              className={cs(
                  "contactus_form",
                  {
                    "success": success,
                    "error": error
                  }
              )}
          >
            <h2 className="header" dangerouslySetInnerHTML={{ __html: title || 'Order a design' }} />
            <p>Tell us about your project, and we’ll get in touch with you to discuss.</p>
            <form onSubmit={onSubmit}>
              <ContactFormInput
                  placeholder="Company name"
                  name="company"
                  onChange={setCompany}
              />
              <ContactFormInput
                  placeholder={width > 600 ? "A brief overview of your project and approximate budget " : "A brief overview of your project"}
                  name="project"
                  onChange={setProject}
              />
              <ContactFormInput
                  placeholder="Email"
                  name="email"
                  onChange={setEmail}
              />
              <ContactFormInput
                  placeholder="Phone"
                  name="Phone"
                  onChange={setPhone}
              />
              <ContactFormInput
                  placeholder="Name"
                  name="name"
                  onChange={setName}
              />
              <ContactFormInput
                  placeholder="Country"
                  name="country"
                  onChange={setCountry}
              />
              <button type="submit">Send your request</button>
              <input type="hidden" name="form_id" value={formId} />
            </form>
            <div className="contactus_success">
              <h2>Thanks! We've got your message. <br/> We'll be in touch soon.</h2>
            </div>
            <div className="contactus_error">
              <h2>Something went wrong. <br/> Please try againt later.</h2>
            </div>
          </div>
        </section>
      </React.Fragment>
  );
}

export default ContactFormEn;
